/**
 * Lib.Common: v-label-back directive
 *
 * Event handler for v-label `back` action button.
 */


function bind(el, binding, vnode) {
    el._lback = binding.value;
}


function unbind(el) {
    delete el._lback;
}


export default {
    name: 'label-back',
    directive: {
        bind,
        unbind,
        update: bind
    }
};
